const getters = {

    // getFlightList: (state) => {

    //     return state.flightList
    // },
    getTabName: (state) => state.tabName,
    getFilter: (state) => state.filter,
    getCurrentIndex: (state) => state.currentIndex,
    getChoseTicket: (state) => state.choseTickets,
    getFreeFlight: (state) => state.freeFlight,
    getFlightAllPriceInfo: (state) => state.flightAllPriceInfo,
    getRxjsMsg: (state) => state.rxjsMsg,
    getSort: (state) => state.sort,
    getLoading: (state) => state.loading,
    showErrormsg: (state) => state.errormsg,
    getParameter3: (state) => state.parameter3,
    getlistNum: (state) => state.listNum,
    // 是否展示加载数据小飞机
    getShowProgress: (state) => {
        return state.showProgress
    },
    getDialogVisible: (state) => state.dialogVisible,
    // getReloadProgress: (state) => state.reloadProgress,
    getProgressSuccess: (state) => {
        return state.progressSuccess
    },
    getDirectionId: (state) => {
        return state.directionId
    },
    getTicketIndex: (state) => {
        return state.ticketIndex
    },
    getPriceDetailInfo: (state) => {
        return state.priceDetailInfo
    },
}
export default getters